import React from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/footer.css';

const TikTokIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" viewBox="0 0 16 16">
        <path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z" />
    </svg>
);

export default function Footer() {
    return (
        <footer className="ft-root">

            {/* ── Top Strip ── */}
            <div className="ft-top-strip">
                <div className="ft-top-inner">
                    <span className="ft-strip-text">Perfume Paris</span>
                    <div className="ft-strip-dividers">
                        {['Free Shipping Over ₹2000', 'Authentic Luxury', '100% Original', 'Gift Wrapping'].map(t => (
                            <span key={t} className="ft-strip-item">{t}</span>
                        ))}
                    </div>
                </div>
            </div>

            {/* ── Main Columns ── */}
            <div className="ft-main">

                {/* Brand */}
                <div className="ft-brand-col" style={{ textAlign: 'left' }}>
                    <Link to="/" className="ft-brand-logo" style={{ textDecoration: 'none' }}>
                        <span className="ft-brand-wordmark">
                            <span className="ft-brand-ar">AR</span>
                            <span className="ft-brand-perfume">PERFUME</span>
                        </span>
                    </Link>
                    <p className="ft-brand-desc">
                        Discover the essence of luxury. Crafted with the world's finest
                        ingredients, our perfumes offer a unique and unforgettable
                        olfactory experience — a fragrance for every story.
                    </p>
                    <span className="ft-social-label">Follow Us</span>
                    <div className="ft-social-icons">
                        <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" className="ft-social-link" aria-label="Facebook">
                            <i className="fa fa-facebook" />
                        </a>
                        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" className="ft-social-link" aria-label="Instagram">
                            <i className="fa fa-instagram" />
                        </a>
                        <a href="https://www.tiktok.com/" target="_blank" rel="noopener noreferrer" className="ft-social-link" aria-label="TikTok">
                            <TikTokIcon />
                        </a>
                    </div>
                </div>

                {/* Customer Service */}
                <div>
                    <h4 className="ft-col-heading" style={{ textAlign: 'left' }}>Customer Service</h4>
                    <div style={{ textAlign: 'left' }}>
                        <div className="ft-contact-item">
                            <span className="ft-contact-icon">✉</span>
                            <a href="mailto:rambabuy721@gmail.com" className="ft-contact-text">
                                rambabuy721@gmail.com
                            </a>
                        </div>
                        <div className="ft-contact-item">
                            <span className="ft-contact-icon">✆</span>
                            <a href="tel:+34600099123" className="ft-contact-text">
                                +34 600 099 123
                            </a>
                        </div>
                        <div className="ft-contact-item">
                            <span className="ft-contact-icon">◷</span>
                            <span className="ft-contact-text">Mon – Sat, 10am – 7pm</span>
                        </div>
                        <div style={{ marginTop: '22px' }}>
                            <Link to="/contact" className="ft-contact-text" style={{ borderBottom: '1px solid rgba(201,161,117,0.4)', paddingBottom: '2px', color: '#c9a175' }}>
                                Contact Us →
                            </Link>
                        </div>
                    </div>
                </div>

                {/* About */}
                <div>
                    <h4 className="ft-col-heading" style={{ textAlign: 'left' }}>About Us</h4>
                    <ul className="ft-link-list" style={{ textAlign: 'left' }}>
                        <li><Link to="/about">Our Story</Link></li>
                        <li><Link to="/shop">Our Products</Link></li>
                        <li><Link to="/blogs">Journal &amp; Blog</Link></li>
                        <li><Link to="/terms">Terms &amp; Conditions</Link></li>
                        <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                    </ul>
                </div>

                {/* Catalog */}
                <div>
                    <h4 className="ft-col-heading" style={{ textAlign: 'left' }}>Collections</h4>
                    <ul className="ft-link-list" style={{ textAlign: 'left' }}>
                        <li><Link to="/for-him">Fragrances for Him</Link></li>
                        <li><Link to="/for-her">Fragrances for Her</Link></li>
                        <li><Link to="/shop">All Collections</Link></li>
                        <li><Link to="/collections">New Arrivals</Link></li>
                    </ul>
                </div>

            </div>

            {/* ── Divider ── */}
            <div className="ft-gold-rule"><hr /></div>

            {/* ── Bottom Bar ── */}
            <div className="ft-bottom">
                <p className="ft-copyright">
                    Copyright &copy; {new Date().getFullYear()} <span>AR Perfumes</span>. All rights reserved.
                </p>
                <div className="ft-bottom-links">
                    <Link to="/privacy-policy">Privacy Policy</Link>
                    <Link to="/terms">Terms of Use</Link>
                    <Link to="/contact">Support</Link>
                </div>
            </div>

        </footer>
    );
}
